<fa-icon [icon]="faSpinner" size="lg" animation="spin"></fa-icon>
